module.exports = __webpack_public_path__ + "img/Green-stamp.6dc8eb7a.webp";